<template>
<div class='project-dialog'>
  <el-dialog size='tiny' @close='dialogVisible = false' :visible.sync="dialogVisible">
    <div class='qrcode-wrapper'>
      <img class='qrcode' :src="'//qrcode.ppj.io/' + link" />
      <p class='hint'>{{$t('qrcode.project')}}</p>
      <div class='link-info'>
        <el-input :placeholder="$t('placeholder.project.viewer_url')" v-model='link' class='link-input' readonly>
          <div class='append-buttons' slot='append'>
            <a class='copy el-button' v-clipboard:copy="link" v-clipboard:success="onCopy">
                  {{$t('common.buttons.copy')}}
              </a>
            <a class='preview el-button' :href="link" target='_blank'>
                  {{$t('common.buttons.preview')}}
              </a>
          </div>
        </el-input>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  data() {
    return {
      link: null,
      dialogVisible: false
    }
  },
  methods: {
    onCopy: function(e) {
      this.$message({
        message: this.$t('common.infos.copy'),
        type: 'success'
      })
    },
    open(project) {
      this.dialogVisible = true
      this.link = project.viewer_url
    },
    close() {
      this.dialogVisible = false
      this.link = null
    }
  }
}
</script>

<style lang='scss' scoped>
$qrcode-wrapper-width: 100%;

.project-dialog {
    .qrcode-wrapper {
        width: $qrcode-wrapper-width;
        background-color: #FDFDFD;
        padding: 20px 0;
        text-align: center;

        .qrcode {
            width: 0.6 * $qrcode-wrapper-width;
            height: 0.6 * $qrcode-wrapper-width;
        }

        .link-info {
            width: 0.9 * $qrcode-wrapper-width;
            margin: 0 auto;
            border-top: $border-base;
            padding: $padding-base 0 0;
            font-size: $font-size-small;
            overflow: hidden;
            text-align: left;
            line-height: 1.2;

            .link-input {
                font-size: $font-size-small;
            }

            $inner-button-width: 32px;
            .append-buttons {
                display: table;
                margin: 0 -10px;
                .el-button {
                    display: table-cell;
                    border: none;
                    margin: 0;
                    padding: 0 0.6em;
                    height: 30px;
                    line-height: 30px;
                    color: $font-color-base;
                    background-color: $color-white-base;
                    &.copy {
                        border-right: $border-base;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// project.dialog.vue?e9891164